module.exports = __webpack_public_path__ + "img/Balanceakt.9be7c299.svg";